const charityQuestions = [
  {
    key: 'isCharityLeader',
    label: 'Are you the Executive Director, Board Chair, or Chair of the Fundraising Committee of a Canadian charity or nonprofit organization registered in Canada?',
    options: {
      yes: 'Yes',
      no: 'No',
    },
  },
  {
    key: 'facesFundraisingChallenges',
    label: 'Does your charity or nonprofit currently face challenges raising enough funds to support its operations, programs or activities?',
    options: {
      yes: 'Yes',
      no: 'No',
    },
  },
  {
    key: 'fundraisingChallenges',
    label: 'If yes, what fundraising challenges does your organization face? Select all that apply.',
    options: {
      limited_grants: 'Limited access to government grants or institutional funding',
      attracting_donors: 'Difficulty attracting new donors',
      retaining_donors: 'Difficulty retaining existing donors and encouraging repeat donations',
      limited_capacity: 'Limited staff time, fundraising expertise or organizational capacity',
      insufficient_marketing: 'Insufficient funding for marketing, communications and donor outreach',
      low_awareness: 'Low public awareness of our organization or cause',
      standing_out: 'Difficulty standing out among the many organizations seeking donations',
      donor_fatigue: 'Donor fatigue or declining willingness to give',
      rising_costs: 'Rising operating and program costs without a corresponding increase in donations',
      limited_digital_tools: 'Limited access to affordable and effective digital fundraising tools',
      major_donor_relationships: 'Difficulty building relationships with businesses, foundations or major donors',
      unpredictable_revenue: 'Unpredictable or seasonal donation revenue, making long-term planning difficult',
      other: 'Other (please specify)',
      not_sure: 'Not sure / Prefer not to say',
    },
  },
  {
    key: 'fundraisingChallengesOther',
    label: 'Other fundraising challenge (please specify)',
  },
  {
    key: 'servicePlan',
    label: 'Which service plan would your organization be inclined to subscribe to when raising funds through an online fundraising platform such as CanadaHelps?',
    options: {
      basic: 'Basic Plan — free to the charity (essential crowdfunding services)',
      growth: 'Growth Plan — subscription-based pricing (campaign optimization, advisor, CRM, human and AI donor intelligence, etc.)',
      enterprise: 'Enterprise Plan — custom pricing (strategist, grant writing, donation button, event ticketing, Gively account administration, white-label ecosystem, etc.)',
      accelerate: 'Accelerate Plan — legacy option',
      none: 'None of these options',
    },
  },
  {
    key: 'earlyPilot',
    label: 'Would you like to participate as an early charity in the Gively platform pilot project to test these plans?',
    options: {
      yes: 'Yes.',
      need_more_info: 'I need more information to decide.',
      no: 'No, thank you.',
    },
  },
]

const donorQuestions = [
  {
    key: 'canadianResident',
    label: 'Are you a Canadian citizen or currently living in Canada with valid legal status?',
    options: {
      yes: 'Yes',
      no: 'No',
      prefer_not: 'Prefer not to answer',
    },
  },
  {
    key: 'ageGroup',
    label: 'What is your age group?',
    options: {
      under_18: 'Under 18',
      '18_24': '18–24',
      '18-24': '18–24',
      age_18_24: '18–24',
      '25_34': '25–34',
      '25-34': '25–34',
      age_25_34: '25–34',
      '35_44': '35–44',
      '35-44': '35–44',
      age_35_44: '35–44',
      '45_54': '45–54',
      '45-54': '45–54',
      age_45_54: '45–54',
      '55_64': '55–64',
      '55-64': '55–64',
      age_55_64: '55–64',
      '65_74': '65–74',
      '65-74': '65–74',
      age_65_74: '65–74',
      '75_plus': '75 or older',
      '75-plus': '75 or older',
      age_75_plus: '75 or older',
    },
  },
  {
    key: 'donationFrequency',
    label: 'How often do you donate through an online giving platform or directly on the website of the charity or non-profit?',
    options: {
      monthly: 'Monthly',
      several_times_year: 'Several times a year',
      once_or_twice_year: 'Once or twice a year',
      occasionally: 'Occasionally',
      not_recently: 'I have not donated recently but may do so in the future',
      do_not_intend: 'I do not intend to donate',
    },
  },
  {
    key: 'preferredRewards',
    label: 'Below is a list of proposed advantages, rewards and benefits that a donor may opt to receive when they donate to a charity or fundraiser through the Gively platform. Please select those rewards and benefits that may inspire you to donate (more) to a charity or nonprofit.',
    options: {
      giving_recognition: 'Giving Recognition — Digital badge, Lifelong Impact Certificate, and progress through donor-recognition levels.',
      impact_information: 'Impact Information — Personalized impact updates, cause briefings, webinars, and opportunities to learn about participating charities.',
      donation_receipts: 'Donation receipts — Used to claim income tax credits. Issued by the recipient charity or non-profit through the Gively platform.',
      participation_community: 'Participation and Community — Vote for featured campaigns, and invitations to advisory panels, impact forums, galas, etc.',
      everyday_rewards: 'Everyday Rewards — Redemption of GLT at selected retail, dining, delivery, or entertainment stores.',
      travel_premium: 'Travel and Premium Experiences — Redemption of GLT for selected travel, airport-lounge, fine dining, wellness, or other premium experiences.',
      none: 'Advantages, recognition, or rewards would not influence my giving.',
    },
  },
  {
    key: 'earlyTesting',
    label: 'Would you be interested in participating in a pilot to test the viability of the Gively rewards and benefits program?',
    options: {
      yes: 'Yes.',
      need_more_info: 'I need more information to decide.',
      no: 'No, thank you.',
    },
  },
  // Legacy v3/v4 keys kept so older submissions still render.
  {
    key: 'claimedAdvantages',
    label: 'Which of the following advantages have you ever claimed or accepted from a charitable donation?',
    options: {
      tax_credit: 'Income tax credit using my charitable donation receipt.',
      draw_50_50: 'Participation in a 50:50 draw.',
      auction: 'Participation in an auction.',
      recognition: 'Accepting a charity certificate, invitation to a gala, banquet, etc. or any other form of recognition for your charitable donation.',
      never: 'I have never claimed or accepted an advantage from my charitable donation.',
      prefer_not_to_say: 'I prefer not to say.',
    },
  },
  {
    key: 'engagementRanking',
    label: 'Which of the following rewards or benefits would motivate you to donate (more) through a crowdfunding platform? (ranked most to least motivating)',
    ranked: true,
    options: {
      giving_recognition: 'Giving Recognition',
      impact_information: 'Impact Information',
      participation_community: 'Participation and Community',
      everyday_rewards: 'Everyday Rewards',
      travel_premium: 'Travel and Premium Experiences',
      combination: 'A Combination of Recognition, Impact, Participation and Rewards.',
      none: 'Recognition or rewards would not influence my giving.',
    },
  },
  {
    key: 'advantagePreference',
    label: 'Which of the following advantages would you prefer to get when you donate through a crowdfunding platform?',
    options: {
      tax_receipt: 'A donation receipt which can be used to claim an income tax credit.',
      glt_receipt: 'A donation receipt which allows you to claim GLT rewards/benefits but cannot be used to claim an income tax credit.',
      depends_on_glt_value: 'It would depend on the estimated value of the GLT rewards.',
      no_advantage: 'I will not claim any advantage, be it a tax credit or any other rewards or benefits.',
    },
  },
]

/** Current frontend survey fields only (excludes legacy v3/v4 keys). */
var CURRENT_CHARITY_EXPORT_KEYS = [
  'isCharityLeader',
  'facesFundraisingChallenges',
  'fundraisingChallenges',
  'fundraisingChallengesOther',
  'servicePlan',
  'earlyPilot',
]

var CURRENT_DONOR_EXPORT_KEYS = [
  'canadianResident',
  'ageGroup',
  'donationFrequency',
  'preferredRewards',
  'earlyTesting',
]

function questionByKey(questions, key) {
  for (var i = 0; i < questions.length; i += 1) {
    if (questions[i].key === key) {
      return questions[i]
    }
  }
  return null
}

function humanizeKey(key) {
  return String(key || '')
    .replace(/([A-Z])/g, ' $1')
    .replace(/[_-]+/g, ' ')
    .replace(/^\s+/, '')
    .replace(/^./, function (char) {
      return char.toUpperCase()
    })
}

function normalizeAnswers(rawAnswers) {
  if (!rawAnswers || typeof rawAnswers !== 'object' || Array.isArray(rawAnswers)) {
    return {}
  }
  if (typeof rawAnswers.toObject === 'function') {
    return normalizeAnswers(rawAnswers.toObject())
  }
  // Support accidental nesting like { answers: { ageGroup: ... } }
  if (
    rawAnswers.answers
    && typeof rawAnswers.answers === 'object'
    && !Array.isArray(rawAnswers.answers)
    && !rawAnswers.ageGroup
    && !rawAnswers.isCharityLeader
    && !rawAnswers.donationFrequency
  ) {
    return normalizeAnswers(rawAnswers.answers)
  }
  try {
    return JSON.parse(JSON.stringify(rawAnswers))
  } catch (error) {
    var copy = {}
    Object.keys(rawAnswers).forEach(function (key) {
      copy[key] = rawAnswers[key]
    })
    return copy
  }
}

function labelForOption(question, value) {
  if (!question || value == null || value === '') {
    return '—'
  }
  if (question.options && question.options[value]) {
    return question.options[value]
  }
  return String(value)
}

function formatAnswerValue(question, rawValue) {
  if (rawValue == null || rawValue === '') {
    return '—'
  }

  if (Array.isArray(rawValue)) {
    if (!rawValue.length) {
      return '—'
    }
    if (question && question.ranked) {
      return rawValue.map(function (value, index) {
        return (index + 1) + '. ' + labelForOption(question, value)
      }).join('\n')
    }
    return rawValue.map(function (value) {
      return labelForOption(question, value)
    }).join('\n')
  }

  return labelForOption(question, rawValue)
}

function shouldIncludeQuestion(question, answers) {
  var hasKey = Object.prototype.hasOwnProperty.call(answers, question.key)
    || Object.keys(answers).indexOf(question.key) !== -1
  if (!hasKey) {
    return false
  }

  var value = answers[question.key]
  if (value == null || value === '') {
    return false
  }
  if (Array.isArray(value) && !value.length) {
    return false
  }

  if (question.key === 'fundraisingChallenges' && answers.facesFundraisingChallenges !== 'yes') {
    return false
  }

  if (question.key === 'fundraisingChallengesOther') {
    var challenges = answers.fundraisingChallenges
    var hasOther = Array.isArray(challenges) && challenges.indexOf('other') !== -1
    return hasOther && !!answers.fundraisingChallengesOther
  }

  return true
}

export function getQuestionsForAudience(audience) {
  return audience === 'charity' ? charityQuestions : donorQuestions
}

export function buildReadableAnswers(response) {
  if (!response) {
    return []
  }

  var questions = getQuestionsForAudience(response.audience)
  var answers = normalizeAnswers(response.answers)
  var knownKeys = {}
  var rows = []
  var currentKeys = response.audience === 'charity'
    ? CURRENT_CHARITY_EXPORT_KEYS
    : CURRENT_DONOR_EXPORT_KEYS

  // Always show every current frontend field for this audience, in survey order.
  currentKeys.forEach(function (key) {
    var question = questionByKey(questions, key)
    if (!question) {
      return
    }
    knownKeys[key] = true

    // Skip conditional charity follow-up when the gate answer is No.
    if (key === 'fundraisingChallenges' && answers.facesFundraisingChallenges !== 'yes') {
      return
    }
    if (key === 'fundraisingChallengesOther') {
      var selectedChallenges = answers.fundraisingChallenges
      var choseOther = Array.isArray(selectedChallenges) && selectedChallenges.indexOf('other') !== -1
      if (!choseOther) {
        return
      }
    }

    var value = answers[key]
    var hasValue = !(value == null || value === '' || (Array.isArray(value) && !value.length))
    rows.push({
      number: rows.length + 1,
      key: key,
      question: question.label,
      answer: hasValue ? formatAnswerValue(question, value) : '—',
      isMultiline: Array.isArray(value),
    })
  })

  // Surface any additional stored keys (legacy or unexpected) after the current set.
  questions.forEach(function (question) {
    if (knownKeys[question.key]) {
      return
    }
    knownKeys[question.key] = true
    if (!shouldIncludeQuestion(question, answers)) {
      return
    }
    rows.push({
      number: rows.length + 1,
      key: question.key,
      question: question.label,
      answer: formatAnswerValue(question, answers[question.key]),
      isMultiline: Array.isArray(answers[question.key]),
    })
  })

  Object.keys(answers).forEach(function (key) {
    if (knownKeys[key]) {
      return
    }
    var value = answers[key]
    if (value == null || value === '') {
      return
    }
    if (Array.isArray(value) && !value.length) {
      return
    }
    rows.push({
      number: rows.length + 1,
      key: key,
      question: humanizeKey(key),
      answer: formatAnswerValue(null, value),
      isMultiline: Array.isArray(value),
    })
  })

  if (response.additionalComments) {
    rows.push({
      number: rows.length + 1,
      key: 'additionalComments',
      question: 'Additional comments',
      answer: response.additionalComments,
      isMultiline: true,
    })
  }

  return rows
}

export function buildReadableContact(contact) {
  var safeContact = contact || {}
  return [
    { label: 'Organization name', value: safeContact.organizationName || '—' },
    { label: 'Name', value: safeContact.name || '—' },
    { label: 'Official position', value: safeContact.position || '—' },
    { label: 'Email', value: safeContact.email || '—' },
    { label: 'Province or territory', value: safeContact.province || '—' },
  ]
}

export function getExportAnswerColumnLabels() {
  var labels = []
  var seen = {}

  function addFrom(questions, keys) {
    keys.forEach(function (key) {
      var question = questionByKey(questions, key)
      if (!question || seen[question.label]) {
        return
      }
      seen[question.label] = true
      labels.push(question.label)
    })
  }

  addFrom(charityQuestions, CURRENT_CHARITY_EXPORT_KEYS)
  addFrom(donorQuestions, CURRENT_DONOR_EXPORT_KEYS)
  return labels
}

export function flattenReadableAnswersForExport(response) {
  var flat = {}
  var rows = buildReadableAnswers(response)
  rows.forEach(function (row) {
    flat[row.question] = String(row.answer || '').replace(/\n/g, ' | ')
  })

  // Guarantee every current frontend field appears as a column, even when blank
  // for this audience/response (so CSV headers stay complete for charity + donor).
  var audience = response && response.audience
  var questions = getQuestionsForAudience(audience)
  var keys = audience === 'charity' ? CURRENT_CHARITY_EXPORT_KEYS : CURRENT_DONOR_EXPORT_KEYS
  keys.forEach(function (key) {
    var question = questionByKey(questions, key)
    if (!question) {
      return
    }
    if (!Object.prototype.hasOwnProperty.call(flat, question.label)) {
      flat[question.label] = ''
    }
  })

  return flat
}
